// removed by extract-text-webpack-plugin
module.exports = {"definitionList":"DefinitionList-hashed__definitionList__3ryC8","hasTitle":"DefinitionList-hashed__hasTitle__QrVXJ","title":"DefinitionList-hashed__title__W1a2v"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/definition-list/DefinitionList/DefinitionList-hashed.scss
// module id = 1200
// module chunks = 0